import { render, staticRenderFns } from "./BrandStory3.vue?vue&type=template&id=23f465b4&"
import script from "./BrandStory3.vue?vue&type=script&lang=js&"
export * from "./BrandStory3.vue?vue&type=script&lang=js&"
import style0 from "./BrandStory3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports